import React from 'react';
import useFadeIn from '@nooks/use-fade-in';

const FadeIn = ({ children, tag: Tag = 'div', duration = 300, ...rest }) => {
  const fadeIn = useFadeIn(duration / 1000);
  return <Tag {...rest} {...fadeIn}>{children}</Tag>;
};

export default FadeIn;
